type UserProfileClaims = Record<string, unknown>;

const EMAIL_CLAIMS = ['email', 'preferred_username', 'upn', 'mail'];

const getStringClaim = (
  profile: UserProfileClaims | null | undefined,
  claimNames: string[],
) => {
  if (!profile) return undefined;

  for (const claimName of claimNames) {
    const claimValue = profile[claimName];
    if (typeof claimValue === 'string' && claimValue.trim()) {
      return claimValue.trim();
    }
  }

  return undefined;
};

const formatEmailSegment = (segment: string) =>
  segment
    ? `${segment[0].toUpperCase()}${segment.slice(1).toLowerCase()}`
    : segment;

const formatHarnessEmailKey = (email: string) => {
  const emailParts = email.trim().split('@');
  if (emailParts.length !== 2 || !emailParts[0] || !emailParts[1]) {
    return email.trim();
  }

  const [localPart, domain] = emailParts;
  const harnessLocalPart = localPart
    .split('.')
    .map(formatEmailSegment)
    .join('.');

  return `${harnessLocalPart}@${domain.toLowerCase()}`;
};

export const getHarnessTrafficKey = (
  profile: UserProfileClaims | null | undefined,
) => {
  const email = getStringClaim(profile, EMAIL_CLAIMS);
  return email ? formatHarnessEmailKey(email) : 'anonymous';
};
